import React from 'react'
import classes from './style.module.scss'
import PropTypes from 'prop-types'

export const InputLabel = ({ style, text, hasAsterisk, hideHeight }) => {
	return (
		text && (
			<div className={`${classes.InputLabel} ${hideHeight ? '' : classes.height}`} style={style}>
				{text}
				{hasAsterisk ? '*' : ''}
			</div>
		)
	)
}

InputLabel.propTypes = {
	style: PropTypes.object,
	text: PropTypes.string,
	hasAsterisk: PropTypes.bool,
	clickHandler: PropTypes.func,
}

InputLabel.defaultProps = {
	style: {},
	text: 'Label',
	description: '',
	hasAsterisk: false,
	clickHandler: () => {},
	onOpenDescription: () => {},
}
